export const defaultInitState = {
    page: {
        size: 0,
        totalElements: 0,
        totalPages: 0,
        number: 0
    },
    items: [],
    loading: false
}

export const saveAction = (state, action) => {
    state.items = action.payload.items;
    state.page = action.payload.page;
}

export const setLoaderAction = (state, action) => {
    state.loading = action.payload;
}
